import omniChartsService from './reducers';

import * as omniChartsServiceOperations from './operations';
import * as omniChartsServiceTypes from './types';
import * as omniChartAction from './actions';

export { omniChartsServiceOperations, omniChartsServiceTypes, omniChartAction };

export default omniChartsService;
